import { useStyles } from "./PageContent.styles";
import type { PageContentProps } from "./types";

/**
 * This is a custom MyEROAD component.
 * PageContent provides standard padding for page content.
 *
 * PageContent is not positioned relative by default. The primary reason is
 * PageSpinner and PageError look best centered against Page, but PageContent
 * consumers often render them inside PageContent. That's fine with relative
 * positioning off. If you turn relative positioning on, ensure that you
 * render PageSpinner/PageError _or_ PageContent, and not PageSpinner/PageError
 * _inside_ PageContent. The only known use case for turning relative positioning
 * on is implementing an unscrollable page (i.e. content might scroll in absolute
 * containers within the viewport, but the page itself won't scroll). Thus you
 * can turn relative positioning on using forAnUnscrollablePage, but note the above.
 */
const PageContent = ({ children, forAnUnscrollablePage }: PageContentProps) => {
  const classes = useStyles({
    relative: forAnUnscrollablePage,
    withMargin: !forAnUnscrollablePage,
  });

  return <section className={classes.root}>{children}</section>;
};

export { PageContent };
